import type { MailFolderTableQuery, TableView } from "owa-mail-list-store";
import { type SortColumn } from "owa-mail-list-store";
import { isLocalDataBackedMailboxInfo } from "owa-account-source-list/lib/utils/isLocalDataBackedAccount";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";

const SUPPORTED_JUMPTO_SORT_COLUMNS = [
    3,
    9,
    8,
    5,
    1,
    14,
    7,
];

export default function shouldShowJumpTo(tableView: TableView | undefined): boolean {
    const tableQuery = tableView?.tableQuery as MailFolderTableQuery;
    const sortColumn = tableQuery?.sortBy?.sortColumn;
    const mailboxInfo = getMailboxInfo(tableView);
    
    return (!!tableView &&
        SUPPORTED_JUMPTO_SORT_COLUMNS.includes(sortColumn) &&
        !isLocalDataBackedMailboxInfo(mailboxInfo) && // Don't show JumpTo for PST files
        !isUnifiedInboxMailboxInfo(mailboxInfo) // Don't show JumpTo for Unified Inbox
    );
}
